import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import * as kRoutes from "../../constants/routes";
import {
  setAnalyticsClickModalLimitFree,
  setAnalyticsViewModalLimitFree,
} from "../../helpers/analyticsHelpers";
import { Box, Modal, Stack, Typography } from "@mui/material";
import RoundedButton from "components/Buttons/RoundedButton";
import RoundedButtonOutlined from "components/Buttons/RoundedButtonOutlined";
import { Close } from "@mui/icons-material";
import { useUserAccountInfos } from "hooks/useUserInfos";

const ModalLimitPlays = ({
  openModal,
  setOpenModal,
  setOpenGame = () => {},
  onClose = null,
  setInfoActivity
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { data: currentUser } = useUserAccountInfos();

  useEffect(() => {
    if (openModal && currentUser) {
      setAnalyticsViewModalLimitFree();
    }
  }, [openModal, currentUser]);

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleSeePlans = () => {
    setAnalyticsClickModalLimitFree({
      name: "Assinar Plano",
    });
    setOpenModal(false);
    setOpenGame(false);
    navigate(kRoutes.R_BUY);
    setInfoActivity(false);
  };

  const handleContactCommercial = () => {
    setAnalyticsClickModalLimitFree({
      name: "Falar com time comercial",
    });
    setOpenModal(false);
    setOpenGame(null);
    setInfoActivity(false);
  };

  return (
    <Box>
      <Modal open={Boolean(openModal)} onClose={handleClose}>
        <Box
          sx={{
            width: "100%",
            maxWidth: { xs: "400px", sm: "450px" },
            height: "650px",
            background: "#FDFDFD",
            opacity: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            borderRadius: "12px",
          }}
        >
          <Stack
            sx={{
              background: "rgba(238, 232, 242, 0.40)",
              width: "100%",
              height: "90px",
              p: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              borderRadius: "12px 12px 0 0",
            }}
          >
            <Typography
              sx={{
                textTransform: "uppercase",
                textAlign: "center",
                fontWeight: 700,
                color: "#662D91",
                fontSize: { xs: "18px", sm: "20px" },
              }}
            >
              {t("global.unlock_access")}
              <br /> {t("global.unlimited_to_games")}
            </Typography>
            <Close
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 20,
                top: "20%",
                cursor: "pointer",
              }}
            />
          </Stack>
          <Stack sx={{ p: 4 }}>
            <Box sx={{ p: 2, display: "flex", justifyContent: "center" }}>
              <Typography sx={{ textAlign: "center" }}>
                {t("global.sign_up_for_a_plan_to_keep_playing")}
              </Typography>
            </Box>

            <Box
              component="img"
              src="/afinandinho_super_frame.svg"
              alt="Afinandinho voando"
              loading="lazy"
              sx={{
                width: "70%",
                height: "auto",
                display: "block",
                mx: "auto",
                mb: 6,
                mt: 3,
              }}
            />

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <RoundedButton
                text={t("global.view_plans")}
                size="small"
                onClick={handleSeePlans}
              />
              <RoundedButtonOutlined
                text={t("global.speak_to_the_sales_team")}
                size="small"
                href={
                  "https://api.whatsapp.com/send?phone=5515996529210&text=Ol%C3%A1!+Preciso+de+ajuda"
                }
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleContactCommercial}
              />
            </Box>
          </Stack>
        </Box>
      </Modal>
    </Box>
  );
};

export default ModalLimitPlays;
